import React, { useState } from "react";
import "../styles/Blogs.css";
// ── FULL ARTICLE CONTENT (only for blog id: 1) ──────────────────────────────
const ARTICLE_CONTENT = {
  1: {
    sections: [
      {
        heading: "Why Buying a Used Car in Indore Makes Sense",
        body: `Indore is one of the fastest-growing cities in Madhya Pradesh. With expanding road networks, increasing daily commutes and a strong middle-class population, owning a personal vehicle is no longer a luxury — it's a practical need. A pre-owned car gives you the freedom of personal mobility at a fraction of the cost of a new vehicle, without a long waiting period or heavy depreciation hit in the first year.`
      },
      {
        heading: "Step 1 — Set Your Budget Clearly",
        body: `Before you start browsing, fix a realistic budget. Factor in not just the purchase price but also insurance renewal, RC transfer fees, any repair or service costs, and your monthly fuel expense. A car priced at ₹4.5 lakh may need ₹30,000–₹50,000 in repairs or tyres — always keep a buffer of 10–15% over your stated budget.`
      },
      {
        heading: "Step 2 — Choose the Right Segment",
        body: `In Indore's market, the most popular pre-owned segments are hatchbacks (Maruti Swift, WagonR, Alto), sedans (Honda City, Maruti Dzire) and compact SUVs (Maruti Vitara Brezza, Hyundai Venue). For city driving within Indore, Mhow or Ujjain — a well-maintained hatchback is the most economical and practical choice.`
      },
      {
        heading: "Step 3 — Inspect the Car Thoroughly",
        body: `Never skip the physical inspection. Key things to check:\n\n• Engine bay — look for oil leaks, rust or signs of accident repair\n• Odometer reading — genuine cars with under 60,000 km for a 5-year-old vehicle are ideal\n• Tyre condition — uneven wear indicates suspension or alignment issues\n• Electrical — test all windows, AC, lights, infotainment and sensors\n• Test drive — drive on both city roads and a highway stretch if possible`
      },
      {
        heading: "Step 4 — Verify All Documents",
        body: `This is the most critical step and the most commonly skipped. Always verify:\n\n• RC (Registration Certificate) — must match the seller's identity\n• Insurance — check validity and whether any claims were made\n• NOC (No Objection Certificate) — required if the car is registered outside MP\n• Pollution Under Control (PUC) Certificate\n• Loan clearance letter — if the car had a bank loan, get a Form 35 or NOC from the lender\n• Form 29 & Form 30 — needed for RC transfer at the RTO`
      },
      {
        heading: "Step 5 — Get a Pre-Purchase Inspection Done",
        body: `If you're not mechanically inclined, hire a trusted mechanic or use a platform inspection service to do a 100-point check. This typically costs ₹500–₹1,500 and can save you from lakhs of hidden damage. Caryugo will offer verified inspection reports for listed vehicles at launch.`
      },
      {
        heading: "Step 6 — Negotiate Smartly",
        body: `Once you've done your homework, negotiate based on the car's actual condition — not the listed price. In Indore's market, a genuine 5% to 12% negotiation is common on privately listed cars. Factors that lower the price: higher odometer, pending service, older tyres, or a car that has been listed for more than 30 days.`
      },
      {
        heading: "Step 7 — Complete the RC Transfer",
        body: `After the deal is done, the RC transfer is non-negotiable — it legally makes the car yours. Visit the local RTO in Indore with Form 29, Form 30, the original RC, your Aadhaar and PAN, insurance copy and the seller. The transfer usually takes 7–15 working days and costs around ₹700–₹1,500 depending on the vehicle class.`
      },
      {
        heading: "The Caryugo Promise",
        body: `At Caryugo, we are building a platform where every car listed has been verified, every price is justified by data, and every transaction is supported end-to-end — from discovery to RC transfer. Launching in 2026 across Indore, Mhow, Ujjain, Dewas and Pithampur. Our mission is simple: make buying a used car as trustworthy as buying a new one.`
      }
    ]
  }
};

// ── BLOG DATA ────────────────────────────────────────────────────────────────
const blogs = [
  {
    id: 1,
    title: "How to Buy a Used Car in Indore — A First-Timer's Complete Guide",
    desc: "Buying your first used car can feel overwhelming. From inspection to paperwork, we break down every step so you walk in confident and drive out satisfied.",
    // Indian car dealership / street image
    image: "https://images.unsplash.com/photo-1629824745222-fa9b82c62c8a?w=800&q=80",
    category: "Buying Guide",
    date: "March 2026",
    readTime: "7 min read",
    tag: "Must Read",
    fullArticle: true
  },
  {
    id: 2,
    title: "5 Documents You Must Check Before Buying a Pre-Owned Car",
    desc: "Registration Certificate, Insurance, NOC — do you know what to look for? We list every document you need to verify before signing the deal.",
    image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=600&q=80",
    category: "Buying Guide",
    date: "March 2026",
    readTime: "5 min read",
    tag: null,
    fullArticle: false
  },
  {
    id: 3,
    title: "How to Price Your Car Right Before Selling in Indore",
    desc: "Overpricing keeps buyers away. Underpricing loses you money. Here's how to find the sweet spot using real market data from our region.",
    image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=600&q=80",
    category: "Selling Guide",
    date: "February 2026",
    readTime: "6 min read",
    tag: null,
    fullArticle: false
  },
  {
    id: 4,
    title: "Why Indore's Used Car Market is Growing Faster Than Ever",
    desc: "With increasing demand for personal mobility, rising fuel-efficient models and a growing middle-class buyer base — the pre-owned car market in Indore is booming.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=600&q=80",
    category: "Market Insights",
    date: "February 2026",
    readTime: "4 min read",
    tag: "Trending",
    fullArticle: false
  },
  {
    id: 5,
    title: "Top Pre-Owned Cars Under ₹5 Lakh in Indore — Value Picks for 2026",
    desc: "Budget-conscious? These reliable, well-maintained used cars under ₹5 lakh are some of the best value picks available in our market right now.",
    image: "https://images.unsplash.com/photo-1590362891991-f776e747a588?w=600&q=80",
    category: "Car Tips",
    date: "January 2026",
    readTime: "5 min read",
    tag: null,
    fullArticle: false
  },
  {
    id: 6,
    title: "Caryugo: Why We Built a Transparent Car Platform for Central India",
    desc: "The used car market is broken — hidden charges, untrustworthy dealers, unclear pricing. Here's why we built Caryugo and what makes us genuinely different.",
    image: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=600&q=80",
    category: "About Us",
    date: "January 2026",
    readTime: "3 min read",
    tag: "Our Story",
    fullArticle: false
  }
];

// ── ARTICLE PAGE ─────────────────────────────────────────────────────────────
const ArticlePage = ({ blog, onBack }) => {
  const content = ARTICLE_CONTENT[blog.id];
  return (
    <div className="article-page">
      {/* Back Button */}
      <div className="article-topbar">
        <button className="back-btn" onClick={onBack}>
          ← Back to Blog
        </button>
        <span className="article-topbar-brand">Caryugo Blog</span>
      </div>

      {/* Hero */}
      <div className="article-hero">
        <img src={blog.image} alt={blog.title} />
        <div className="article-hero-overlay" />
        <div className="article-hero-content">
          <span className="pill">{blog.category}</span>
          <h1>{blog.title}</h1>
          <div className="article-meta">
            <span>By Caryugo Editorial Team</span>
            <span className="dot">·</span>
            <span>{blog.date}</span>
            <span className="dot">·</span>
            <span>{blog.readTime}</span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="article-body">
        <p className="article-intro">{blog.desc}</p>
        {content.sections.map((sec, i) => (
          <div key={i} className="article-section">
            <h2>{sec.heading}</h2>
            {sec.body.split("\n\n").map((para, j) => (
              <p key={j}>{para}</p>
            ))}
          </div>
        ))}

        {/* CTA */}
        <div className="article-cta">
          <div className="article-cta-inner">
            <h3>Launching in Your City in 2026</h3>
            <p>Caryugo is coming to Indore, Mhow, Ujjain, Dewas and Pithampur. Be the first to know.</p>
            <div className="article-cta-form">
              <input type="email" placeholder="Enter your email" />
              <button>Notify Me</button>
            </div>
          </div>
        </div>

        <button className="back-link" onClick={onBack}>← Back to all articles</button>
      </div>
    </div>
  );
};

// ── COMING SOON MODAL ─────────────────────────────────────────────────────────
const ComingSoonModal = ({ blog, onClose }) => (
  <div className="modal-backdrop" onClick={onClose}>
    <div className="modal-card" onClick={(e) => e.stopPropagation()}>
      <button className="modal-close" onClick={onClose}>✕</button>
      <div className="modal-img-wrap">
        <img src={blog.image} alt={blog.title} />
        <div className="modal-img-overlay" />
        {blog.tag && <span className="card-tag">{blog.tag}</span>}
      </div>
      <div className="modal-body">
        <span className="card-cat">{blog.category}</span>
        <h2>{blog.title}</h2>
        <p className="modal-desc">{blog.desc}</p>
        <div className="modal-coming-soon">
          <div className="coming-soon-badge">
            <span className="cs-icon">✦</span>
            <span className="cs-text">Full Article Coming Soon</span>
          </div>
          <p>We're working on in-depth, research-backed articles for every topic. This guide will be live before Caryugo launches in 2026.</p>
          <div className="modal-notify">
            <input type="email" placeholder="Get notified when it's live" />
            <button>Notify Me</button>
          </div>
        </div>
        <div className="modal-meta">{blog.date} · {blog.readTime}</div>
      </div>
    </div>
  </div>
);

// ── MAIN BLOGS COMPONENT ──────────────────────────────────────────────────────
const Blogs = () => {
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [openArticle, setOpenArticle] = useState(null);   // full article
  const [modalBlog, setModalBlog] = useState(null);        // coming soon modal

  const categories = ["All", "Buying Guide", "Selling Guide", "Car Tips", "Market Insights", "About Us"];

  const handleRead = (blog) => {
    if (blog.fullArticle) {
      setOpenArticle(blog);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setModalBlog(blog);
    }
  };

  const handleBack = () => {
    setOpenArticle(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ── Full article view ──
  if (openArticle) {
    return <ArticlePage blog={openArticle} onBack={handleBack} />;
  }

  const filtered = blogs.filter((b) => {
    const matchCat = activeCategory === "All" || b.category === activeCategory;
    const matchSearch =
      b.title.toLowerCase().includes(search.toLowerCase()) ||
      b.desc.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  const featured = blogs[0];
  const gridBlogs =
    activeCategory === "All" && !search
      ? filtered.filter((b) => b.id !== 1)
      : filtered;

  return (
    <div className="blogs-page">

      {/* ── HERO ── */}
      <section className="blog-hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-badge">✦ Launching 2026 · Indore, Mhow, Ujjain, Dewas &amp; Pithampur</div>
          <h1 className="hero-title">
            Caryugo <span className="gold">Blog</span>
          </h1>
          <p className="hero-sub">
            Honest insights. Real guidance. Everything about buying &amp; selling cars in your city.
          </p>
          <div className="blog-search-bar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              type="text"
              placeholder="Search articles…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="search-btn">Search</button>
          </div>
        </div>
        <div className="hero-scroll-hint">
          <span>Scroll to explore</span>
          <div className="scroll-line" />
        </div>
      </section>

      {/* ── CATEGORY NAV ── */}
      <nav className="blog-categories">
        <div className="cat-inner">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`cat-btn ${activeCategory === cat ? "active" : ""}`}
              onClick={() => { setActiveCategory(cat); setSearch(""); }}
            >
              {cat}
            </button>
          ))}
        </div>
      </nav>

      {/* ── FEATURED POST ── */}
      {activeCategory === "All" && !search && (
        <section className="featured-section">
          <div className="section-label">✦ Featured Article</div>
          <div className="featured-card" onClick={() => handleRead(featured)}>
            <div className="featured-img-wrap">
              <img src={featured.image} alt={featured.title} />
              <div className="featured-img-overlay" />
            </div>
            <div className="featured-body">
              <span className="pill">{featured.category}</span>
              <h2>{featured.title}</h2>
              <p>{featured.desc}</p>
              <div className="featured-meta">
                <span>{featured.date}</span>
                <span className="dot">·</span>
                <span>{featured.readTime}</span>
              </div>
              <button className="read-btn" onClick={(e) => { e.stopPropagation(); handleRead(featured); }}>
                Read Article →
              </button>
            </div>
          </div>
        </section>
      )}

      {/* ── STATS STRIP ── */}
      {activeCategory === "All" && !search && (
        <div className="stats-strip">
          <div className="stat-item">
            <span className="stat-num">5</span>
            <span className="stat-label">Launch Cities</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-num">2026</span>
            <span className="stat-label">Launch Year</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-num">100%</span>
            <span className="stat-label">Transparent Pricing</span>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <span className="stat-num">Zero</span>
            <span className="stat-label">Hidden Charges</span>
          </div>
        </div>
      )}

      {/* ── BLOG GRID ── */}
      <section className="blog-grid-section">
        {activeCategory === "All" && !search && (
          <div className="section-heading">
            <h2>Latest Articles</h2>
            <p>Stay informed. Buy and sell smarter.</p>
          </div>
        )}

        {gridBlogs.length === 0 ? (
          <div className="no-results">
            No articles found for "<strong>{search || activeCategory}</strong>" — try a different keyword.
          </div>
        ) : (
          <div className="blog-grid">
            {gridBlogs.map((blog) => (
              <article key={blog.id} className="blog-card">
                <div className="card-img-wrap">
                  <img src={blog.image} alt={blog.title} loading="lazy" />
                  {blog.tag && <span className="card-tag">{blog.tag}</span>}
                  {!blog.fullArticle && (
                    <span className="card-coming-soon-badge">Coming Soon</span>
                  )}
                  <div className="card-img-overlay" />
                </div>
                <div className="card-body">
                  <span className="card-cat">{blog.category}</span>
                  <h3>{blog.title}</h3>
                  <p>{blog.desc}</p>
                  <div className="card-footer">
                    <span className="card-meta">{blog.date} · {blog.readTime}</span>
                    <button
                      className={`card-read-btn ${!blog.fullArticle ? "card-read-btn--soon" : ""}`}
                      onClick={() => handleRead(blog)}
                    >
                      {blog.fullArticle ? "Read →" : "Coming Soon"}
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      {/* ── NEWSLETTER CTA ── */}
      <section className="newsletter-section">
        <div className="newsletter-inner">
          <div className="newsletter-text">
            <h3>Get Car Buying Tips in Your Inbox</h3>
            <p>We'll notify you when Caryugo launches in your city. No spam, ever.</p>
          </div>
          <div className="newsletter-form">
            <input type="email" placeholder="Enter your email address" />
            <button>Notify Me at Launch</button>
          </div>
        </div>
      </section>


    </div>
  );
};

export default Blogs;